import React from "react";
import { Link, matchPath, useLocation } from "react-router-dom";
import { Breadcrumbs } from "@mui/material";
import MuiTypography from "../MuiTypography";
import MuiBox from "../MuiBox";
import { adminRoutes } from "navigation/adminNavigation";
import { cn } from "utils/cn";

const BreadCrumb = ({ titleShow = true }) => {
  const location = useLocation();

  // Dashboard page
  if (location.pathname === "/dashboard") {
    return null;
  }

  let relativePath = location.pathname;
  const pathSegments = relativePath.split("/").filter(Boolean);

  let breadcrumbs = [
    <Link
      to={"/dashboard"}
      key={"/dashboard"}
      className={
        "flex items-center gap-1 text-sm text-muted-foreground hover:text-primary"
      }
    >
      Dashboard
    </Link>,
  ];

  let accumulatedPath = "";

  for (let i = 0; i < pathSegments.length; i++) {
    accumulatedPath += `/${pathSegments[i]}`;

    // Find the most specific route that matches the accumulated path
    const matchingRoute = adminRoutes?.find((route) =>
      matchPath({ path: route.path, end: true }, accumulatedPath),
    );

    if (matchingRoute) {
      const label = matchingRoute.title;
      const isLast = i === pathSegments.length - 1;
      let isPresent = breadcrumbs
        ?.map((item) => item?.props?.children)
        ?.includes(label);
      if (!isPresent) {
        breadcrumbs?.push(
          isLast ? (
            <span className={"text-mono text-sm font-normal"}>{label}</span>
          ) : (
            <Link
              to={accumulatedPath}
              className={cn(
                "flex items-center gap-1 text-sm text-muted-foreground hover:text-primary",
              )}
            >
              {label}
            </Link>
          ),
        );
      }
    }
  }

  if (!breadcrumbs.length) return null;

  return (
    <MuiBox
      sx={{
        pb: "16px",
        display: "flex",
        px: 1,
        // flexDirection: { xs: 'column', sm: 'row' },
        flexWrap: "wrap",
        alignItems: { md: "center" },
        gap: 2,
      }}
    >
      <MuiBox
        sx={{
          display: "flex",
          alignItems: "center",
          width: "fit-content",
        }}
      >
        {titleShow && (
          <h1 className="font-medium text-[16px] text-mono ">
            {breadcrumbs.length > 1
              ? breadcrumbs?.[breadcrumbs?.length - 1]?.props?.children
              : "Dashboard"}
          </h1>
        )}
      </MuiBox>

      <MuiBox
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          width: "fit-content",
        }}
      >
        <Breadcrumbs
          maxItems={3}
          separator={
            <MuiTypography
              variant="24"
              fontWeight={500}
              sx={{ color: "text.secondary" }}
            >
              /
            </MuiTypography>
          }
          aria-label="breadcrumb"
        >
          {breadcrumbs}
        </Breadcrumbs>
      </MuiBox>
    </MuiBox>
  );
};

export default BreadCrumb;
